import React , {useState , useEffect , Fragment} from 'react'
import {Tab, TabPanel, Tabs} from "../Tab/Tab"
import OurFeatures from '../Features/OurFeatures';
import HowItWorks from '../How It Works/HowItWorks';
import Testimonials from '../Tetimonials/Testimonials';
import FAQ from '../FAQ/FAQ';
import "./CommonHomeTab.css"
import { RiArrowDownSFill , RiArrowUpSFill } from "react-icons/ri";

const CommonHomeTab = (props:any) => {
  const [featureTabValue, setFeatureTabValue] = useState(0);  
  const handleTabs = (value: any) => {
    setFeatureTabValue(value);
  };
  let mobileviewinitial = window.innerWidth > 770 ? false : true;
  const [ismobileview, setismobileview] = useState(mobileviewinitial);
  const [lastTab,setLastTab] = useState("")
    useEffect(() => {
        function handleresize() {
        if (window.innerWidth > 770) {
            setismobileview(false);
        } else {
            setismobileview(true);
        }
        }
        window.addEventListener("resize", handleresize);
        return () => {
        window.removeEventListener("resize", handleresize);
        };
    }, []);
    const [numberval,setNumberval] = useState(0)

    const handleClick = (e:any,i:number) => {
        setLastTab(e.head);
        {lastTab == e.head ? <>
            {setNumberval(0)} 
            {setLastTab("")}
        </>
        : setNumberval(i+1)}
    }
    const MyArr:any = [{head:"Features",tabName:"OurFeatures"},{head:"How It Works",tabName:"HowItWorks"},{head:"Testimonials",tabName:"Testimonials"},{head:"FAQ",tabName:"FAQ"}]
    const WebView = ()=>{
        return(
            <div className='commonHomePageDiv'>  
            <div className='headingTabs'>
            <Tabs  value={featureTabValue}>
                <Tab className="fourTabs" label="Features" onClick={() => handleTabs(0)}/>
                <Tab className="fourTabs" label="How it Works" onClick={() => handleTabs(1)}/>
                <Tab className="fourTabs" label="Testimonials" onClick={() => handleTabs(2)}/>
                <Tab className="fourTabs" label="FAQ's" onClick={() => handleTabs(3)}/>
            </Tabs>
            </div>
            <div className='headingTabs'> 
                <TabPanel value={featureTabValue} index={0}>
                        <div
                        className="section-title wow fadeInUp"
                        data-wow-delay="0.1s"
                        >
                        <h2>Our Features</h2>
                        </div>
                        {/* <OurFeatures data={props.Arr}/> */}
                </TabPanel>
                <TabPanel value={featureTabValue} index={1}>
                    <div className="section-title wow fadeInUp" data-wow-delay="0.1s">
                        <h2>How It Works</h2>
                    </div>
                    <HowItWorks data={props.Arr} />
                </TabPanel>
                <TabPanel value={featureTabValue} index={2}>
                    <div className="section-title wow fadeInUp" data-wow-delay="0.1s">
                        <h2>Testimonials</h2>
                    </div>
                    <Testimonials data={props.Arr}/>
                </TabPanel>
                <TabPanel value={featureTabValue} index={3} >
                    <div className='mt-110'>
                        <section className="faq">
                            <div className="container">
                            <div className="section-title wow fadeInUp" data-wow-delay="0.1s">
                                <h2>Frequently Asked Questions</h2>
                            </div>
                            <FAQ data={props.Arr}/>
                            </div>
                    </section>
                    </div>
                </TabPanel>
            </div>
            </div>
        )
    }

  return (
    <Fragment>
        {ismobileview ? 
            <>
            <div className='Container1'>
                {MyArr.map((e:any,i:number)=>{
                    return(
                    <div className="question-wrapper">
                        <div className={lastTab !== "" && lastTab === e.head ? 'question qustionActive' : 'question'} onClick={() => handleClick(e,i)}>
                        <div className={lastTab !== "" && lastTab === e.head ? 'normalHeading h6New' : 'normalHeading'} >{e.head}</div> 
                        <div> {lastTab !== "" && lastTab === e.head ? <RiArrowUpSFill /> : <RiArrowDownSFill />}</div>
                        </div>
                        <div className={numberval === 1? 'answer mt10px active' : 'answer mt10px'}>
                            {e.tabName === "OurFeatures" && numberval === 1 ? <OurFeatures data={props.Arr}/> : ""}
                            {e.tabName === "HowItWorks" && numberval === 2 ? <HowItWorks data={props.Arr}/> : ""}
                            {e.tabName === "Testimonials" && numberval === 3 ? <Testimonials data={props.Arr}/> : ""}
                            {e.tabName === "FAQ" && numberval === 4 ? <FAQ data={props.Arr}/> : ""}
                        </div>
                        <div className={numberval === 2? 'answer mt10px active' : 'answer mt10px'}>
                            {e.tabName === "OurFeatures" && numberval === 1 ? <OurFeatures data={props.Arr}/> : ""}
                            {e.tabName === "HowItWorks" && numberval === 2 ? <HowItWorks data={props.Arr}/> : ""}
                            {e.tabName === "Testimonials" && numberval === 3 ? <Testimonials data={props.Arr}/> : ""}
                            {e.tabName === "FAQ" && numberval === 4 ? <FAQ data={props.Arr}/> : ""}
                        </div>
                        <div className={numberval === 3? 'answer mt10px active' : 'answer mt10px'}>
                            {e.tabName === "OurFeatures" && numberval === 1 ? <OurFeatures data={props.Arr}/> : ""}
                            {e.tabName === "HowItWorks" && numberval === 2 ? <HowItWorks data={props.Arr}/> : ""}
                            {e.tabName === "Testimonials" && numberval === 3 ? <Testimonials data={props.Arr}/> : ""}
                            {e.tabName === "FAQ" && numberval === 4 ? <FAQ data={props.Arr}/> : ""}
                        </div>
                        <div className={numberval === 4? 'answer mt10px active' : 'answer mt10px'}>
                            {e.tabName === "OurFeatures" && numberval === 1 ? <OurFeatures data={props.Arr}/> : ""}
                            {e.tabName === "HowItWorks" && numberval === 2 ? <HowItWorks data={props.Arr}/> : ""}
                            {e.tabName === "Testimonials" && numberval === 3 ? <Testimonials data={props.Arr}/> : ""}
                            {e.tabName === "FAQ" && numberval === 4 ? <FAQ data={props.Arr}/> : ""}
                        </div>
                    </div>
                    )
                })}
                <hr />
            </div>
            </>
            : 
            <WebView />
        }
    </Fragment>
  )
}

export default CommonHomeTab

